import React from 'react';
import isUserHavePermission from '../utils/isUserHavePermission';

const Permission = ({ permission, children }) => {
  if (permission === undefined || permission === null) return children;
  const isAllowed = isUserHavePermission(permission);
  return isAllowed ? children : null;
};

export default Permission;
